import { render, staticRenderFns } from "./_page.vue?vue&type=template&id=776cd0ac&scoped=true&"
import script from "./_page.vue?vue&type=script&lang=js&"
export * from "./_page.vue?vue&type=script&lang=js&"
import style0 from "./_page.vue?vue&type=style&index=0&id=776cd0ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776cd0ac",
  null
  
)

export default component.exports